var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconsArrowRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "11pt",
    height: "18pt",
    viewBox: "0 0 11 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    enableBackground: "new"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "cp0"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,18)",
    d: "M 2.394041 18 L 1.030584 16.50646 L 8.209945 9 L 1 1.431525 L 2.424625 0 L 11 9 L 2.394041 18 Z ",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp0)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,18)",
    d: "M -4 23 L 16 23 L 16 -5 L -4 -5 Z ",
    fill: "#677377"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsArrowRight);
export default __webpack_public_path__ + "static/media/iconsArrowRight.e155d10fb8dab7a67fe23a08dc2f7e63.svg";
export { ForwardRef as ReactComponent };